const appCustomTypes = {
    PaketBDCA: {
        BDCA_STANDARD: 'BDCA_STANDARD',
        BDCA_PREMIUM: 'BDCA_PREMIUM',
        BDCA_BASIC: 'BDCA_BASIC'
    }
};

module.exports = {
    appCustomTypes
};